module.exports = __webpack_public_path__ + "img/copy.7333319c.svg";